import React from "react";
import { connect } from "react-redux";
import { Button, Input } from "../../components";
import { Globals, axios } from "../../utils";

class ModalCreateEditRoute extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: "",
      form: {
        description: "",
        user_id: this.props.user.id,
        zones: [],
      },
      edit: false,
      zones: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  abortController = new AbortController();

  componentDidMount() {
    const item = this.props.item;
    if (item) this.edit();

    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  edit = async () => {
    await this.setState(s => ({
      form: {
        ...s.form,
        ...this.props.item,
        zones: this.props.item?.details?.map(i => i?.zone?.id) || [],
      },
      edit: true,
    }));
  }

  load = async () => {
    try {
      const res = await axios.post('admin/sellers/zones', { user_id: this.props.user.id });
      this.setState({ zones: res.data.zones });

    } catch (error) {
      console.log(error)
    }
  }

  isValidForm = () => {
    const { form } = this.state;
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    }

    if (!form.description)
      return onError('Debe ingresar el nombre de la ruta');

    if (!form.zones.length)
      return onError('Debe seleccionar al menos una zona');

    return true;
  }

  handleSubmit = (emitter) => {
    emitter.preventDefault();
    if (!this.isValidForm()) return;

    Globals.setLoading();
    axios
      .post("admin/dispatchroute/create", this.state.form)
      .then(res => {
        Globals.showSuccess(this.props.edit ? "Ruta editada" : "Ruta creada");
        this.props.onClose();
      })
      .catch(err => {
        if (err.response.status === 422) {
          Globals.showError(err?.response?.data?.error);
          return;
        }
        Globals.showError(err?.response?.data?.error);
      })
      .then(() => {
        Globals.quitLoading();
      });
  }

  handleChange = (emitter, index) => {
    const { name, value } = emitter.target;

    if (index !== undefined) {
      const form = Globals.copy(this.state.form);
      form.products[index][name] = value;
      this.setState({ form });

    } else {
      this.setState({
        form: {
          ...this.state.form,
          [name]: value
        }
      });
    }
  }

  toggleZone = (id) => {
    const zones = Globals.copy(this.state.form.zones);
    if (zones.includes(id)) {
      zones.splice(zones.indexOf(id), 1);
    } else {
      zones.push(id);
    }
    this.setState(s => ({ form: { ...s.form, zones } }));
  }

  render() {
    const { form, submitted } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              color=" "
              value={form.description}
              name="description"
              placeholder="Nombre de la ruta"
              className="filter"
              labelClass="filter"
              onChange={this.handleChange}
            />
          </div>
        </div>

        <div>
          <p className="title">Asignar zona</p>
        </div>

        {this.state.zones?.length ? (
          <div className="route-list">
            {this.state.zones.map((item, index) => {
              const isSelected = form.zones.includes(item.id);
              return (
                <div key={index} className="route-item" onClick={() => this.toggleZone(item.id)}>
                  <div className={`checkbox ${isSelected ? 'checked' : ''}`}></div>
                  <p>{item.name}</p>
                </div>
              )
            })}
          </div>
        ) : (
          <div className="no-items">
            <p>No hay registros</p>
          </div>
        )}

        {submitted ? (
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <div id="button" className="d-flex justify-content-center">
            <Button color=" " type="submit" className="primary" disabled={submitted}>
              <span>Guardar</span>
            </Button>
          </div>
        )}
      </form>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(ModalCreateEditRoute);
